import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppErrorBoundaryComponent } from '../../components/error-boundary/app-error-boundary.component';
import { FilterSelectedValue } from '../../hooks/filters/interfaces/filter-selected-value.interface';
import {
  ScenarioPlannerExtended,
  ScenarioPlannerTimeframe,
} from '../../hooks/scenario-planner/scenario-planner.interface';
import { useScenarioPlanner } from '../../hooks/scenario-planner/use-scenario-planner.hook';
import ScenarioPlannerMassEditComponent from './scenario-planner-mass-edit.component';

const ScenarioPlannerDetailsPage = () => {
  const { id } = useParams();

  const { data } = useScenarioPlanner(id);
  const [scenarioPlanner, setScenarioPlanner] = useState<
    ScenarioPlannerExtended | undefined
  >();
  const [scenarioPlannerFilterSel, setScenarioPlannerFilterSel] = useState<
    FilterSelectedValue[]
  >([]);
  const [timeframe, setTimeframe] = useState<ScenarioPlannerTimeframe>();
  useEffect(() => {
    if (data) {
      const { scenarioPlanner, timeframe } = data;
      if (scenarioPlanner) {
        setScenarioPlanner(scenarioPlanner);
        setScenarioPlannerFilterSel(scenarioPlanner.filterSelection);
      }
      if (timeframe) {
        setTimeframe(timeframe);
      }
    }
  }, [data]);
  return (
    // In case of any error when getting the scenario, this component will display the error message.
    <AppErrorBoundaryComponent>
      {!timeframe && id && scenarioPlanner && (
        <div className="scenario-header-container">
          <div className="scenario-top-header-container">
            Invalid timeframe. Please, edit the Scenario to setup a valid
            period.
          </div>
        </div>
      )}
      {id && scenarioPlanner && scenarioPlannerFilterSel && timeframe && (
        <ScenarioPlannerMassEditComponent
          id={id}
          scenarioPlanner={scenarioPlanner}
          timeframe={timeframe}
          scenarioPlannerFilterSel={scenarioPlannerFilterSel}
        />
      )}
    </AppErrorBoundaryComponent>
  );
};

export default ScenarioPlannerDetailsPage;
